export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4810.216d2e7f.jpg";